<template>
<div>
    <div class="gdlr-page-title-wrapper gdlr-parallax-wrapper gdlr-title-normal">
        <div class="gdlr-page-title-overlay vueHeader"></div>
        <div class="gdlr-page-title-container container vueHeader">
            <h2 v-if="speakerDetail && speakerDetail.pageCaption" class="gdlr-page-caption" v-html="speakerDetail.pageCaption"></h2>
            <h2 v-if="speakerDetail && speakerDetail.title" class="gdlr-page-title sands-gdlr-page-title">{{speakerDetail.title}}</h2>
        </div>
    </div>
    <div class="with-sidebar-wrapper vueeee">
        <div class="with-sidebar-container container  gdlr-class-no-sidebar">
            <div class="with-sidebar-left twelve columns">
                <div class="with-sidebar-content twelve columns">
                    <div class="gdlr-item gdlr-item-start-content">
                        <div class="speaker type-speaker status-publish has-post-thumbnail hentry">
                            <div class="gdlr-speaker-info-wrapper sands-gdlr-speaker-info-wrapper">
                                <div class="gdlr-speaker-thumbnail">
                                    <div class="sands-image-colored-overlay-hover ">
                                        <img v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.avatarSquareSmall && speakerDetail.expert.avatarSquareSmall.xxx" :src="speakerDetail.expert.avatarSquareSmall.xxx" alt="Rainer Stropek" width="500" height="333">
                                    </div>
                                </div>
                                <div class="sands-speaker-info-inner">
                                    <div v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.social" class="gdlr-speaker-social gdlr-speaker-social-spleaker-detail" style="font-size:23px;">
                                        <a target="_blank" v-if="speakerDetail.expert.social && speakerDetail.expert.social.facebook" class="gdlr-social-shortcode" :href="speakerDetail.expert.social.facebook"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/facebook.png" alt="facebook-icon"></a>
                                        <a target="_blank" v-if="speakerDetail.expert.social && speakerDetail.expert.social.twitter" class="gdlr-social-shortcode" :href="speakerDetail.expert.social.twitter"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/twitter.png" alt="twitter-icon"></a>
                                        <a target="_blank" v-if="speakerDetail.expert.social && speakerDetail.expert.social.google" class="gdlr-social-shortcode" :href="speakerDetail.expert.social.google"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/googleplus.png" alt="googleplus-icon"></a>
                                        <a target="_blank" v-if="speakerDetail.expert.social && speakerDetail.expert.social.linkedin" class="gdlr-social-shortcode" :href="speakerDetail.expert.social.linkedin"><img src="/wp-content/themes/thekeynote-v1-00/images/social-icon/linkedin.png" alt="linkedin-icon"></a>
                                        <a target="_blank" v-if="speakerDetail.expert.social && speakerDetail.expert.social.blog" class="gdlr-social-shortcode" :href="speakerDetail.expert.social.blog"><img src="/wp-content/themes/sands-events-subtheme/img/blog_Icon_v2.png" alt="blog-icon"></a>
                                    </div>
                                </div>
                                <div class="call-for-action-box old-layout">
                                    <div class="language-dependent-block-visible">
                                        <div style="background-color: #f1f1f1; display: block; padding: 16px 0 10px 0; text-align: center;"><span style="font-size: 24px; color: #000; display: block; font-weight: 600; text-align: center;">Until August 25:</span><br>
                                            <span style="font-size: 16px; color: #000; display: block; text-align: center;">✓ Save up to $373</span><br>
                                            <span style="font-size: 16px; color: #000; display: block; text-align: center;">✓ Team discount</span><br>
                                            <span style="font-size: 16px; color: #000; display: block; text-align: center;">✓ Extra specials for freelancers</span><br>
                                            <a class="cta-transparent" style="background-color: #ed6c84; border-bottom: 3px solid #ed6c84; color: #ffffff; padding: 5px 25px 5px 25px; display: inline-block; text-transform: uppercase; letter-spacing: 2px;" href="/new-york/tickets-ny/">Register now</a></div>
                                    </div>
                                </div>
                            </div>
                            <div class="gdlr-speaker-content-wrapper">
                                <h1 v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.forename && speakerDetail.expert.surname" class="gdlr-speaker-biography-title">{{speakerDetail.expert.forename}} {{speakerDetail.expert.surname}}</h1>
                                <h1 v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.company" class="gdlr-speaker-position">{{speakerDetail.expert.company}}
                                    <p> </p>
                                </h1>
                                <div v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.bio" v-html="speakerDetail.expert.bio" class="gdlr-speaker-content"></div>
                                <h4 v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.forename && speakerDetail.expert.surname" class='single-speaker gdlr-speaker-session-title'>All talks by {{speakerDetail.expert.forename}} {{speakerDetail.expert.surname}}</h4>
                                <div v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.currentTracks && speakerDetail.expert.currentTracks.length">
                                    <div v-for="(aTrack, index) in speakerDetail.expert.currentTracks" :key="index">
                                        <span :style="{'background-color':aTrack.editionColor, 'margin-right': '5px'}" class='speaker-edition-label-display speaker-session-view-location-tag '>{{aTrack.edition}}</span>
                                        - <a :href="aTrack.slug">
                                            <p style='display:inline;'>{{aTrack.name}}</p>
                                        </a><br /><br />
                                    </div>
                                </div>
                                <div v-else>
                                    No current talks available.
                                </div>
                                <hr>
                                <div v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.relatedTracks && speakerDetail.expert.relatedTracks.length">
                                    <h4 v-if="speakerDetail && speakerDetail.expert && speakerDetail.expert.forename && speakerDetail.expert.surname" class='single-speaker gdlr-speaker-session-title'>All talks by {{speakerDetail.expert.forename}} {{speakerDetail.expert.surname}} from other editions</h4>
                                    <div v-for="(aTrack, index) in speakerDetail.expert.relatedTracks" :key="index">
                                        <span :style="{'background-color':aTrack.editionColor, 'margin-right': '5px'}" class='speaker-edition-label-display speaker-session-view-location-tag '>{{aTrack.edition}}</span>
                                        - <a :href="aTrack.slug">
                                            <p style='display:inline;'>{{aTrack.name}}</p>
                                        </a><br /><br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import mockupService from '../services/mockupService.js';

export default {
    name: "SpeakerDetail",
    data() {
        return {
            speakerDetail: mockupService.getMockupDataForSpeakerDetail().then(response => this.speakerDetail = response),
        }
    },
    setup() {
        mockupService.getMockupDataForSpeakerDetail().then((response) => {
            if (response && response.title) {
                var title = document.createElement('title');
                title.innerHTML = response.title;
                var head = document.getElementsByTagName('head')[0];
                head.insertBefore(title, head.firstChild)
            }
            if (response && response.meta) {
                Object.keys(response.meta).forEach(function (key) {
                    var meta = document.createElement('meta');
                    if (key && key.slice(0,2) == 'og') {
                      meta.setAttribute('property', key);                      
                    }else{
                      meta.setAttribute('name', key);
                    }
                    meta.setAttribute('content', response.meta[key]);
                    document.getElementsByTagName('head')[0].appendChild(meta);
                })
            }
            if (response && response.jsonld) {
                var jso = JSON.stringify(response.jsonld);
                var script = document.createElement('script');
                script.type = 'application/ld+json';
                script.innerHTML = jso;
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        })
    },
    created() {},
    props: {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
